import request from '@/utils/request'

// 查询走访任务-移动端
export function queryTask(params) {
    return request({
        url: '/visit-app/query-task',
        method: 'get',
        params: params,
    })
}
// 分页查询走访门店-移动端
export function queryStores(params) {
    return request({
        url: '/visit-app/query-stores',
        method: 'get',
        params: params,
    })
}

// 报备分页查询
export function reportPage(params) {
    return request({
        url: '/report-app/page',
        method: 'get',
        params: params,
    })
}
export function getStatusNum(params) {
    return request({
        url: '/report-app/getStatusNum',
        method: 'get',
        params: params,
    })
}
// 获取字典
export function getDictList(dictType) {
    return request({
        url: '/dict/type/dictList',
        method: 'get',
        params: { dictType }
    })
}
// 报备查询详情
export function getReportDetails(id) {
    return request({
        url: '/report-app/' + id,
        method: 'get',
    })
}
// 提交
export function reportSubmit(data) {
    return request({
        url: 'report-app/submit',
        method: 'post',
        data,
    })
}
// 保存
export function reportSave(data) {
    return request({
        url: 'report-app/save',
        method: 'post',
        data,
    })
}
// 通过 驳回
export function reportUpdateStatus(data) {
    return request({
        url: 'report-app/updateStatus',
        method: 'post',
        data,
    })
}